<template>
  <div>
    <loadingTela v-if="carregando"/>

    <v-card
      :loading="loading"
      class="mx-auto my-12"
      max-width="900"
      style="min-height: 300px"
    >
      <template slot="progress">
        <v-progress-linear
          color="deep-purple"
          height="10"
          indeterminate
        ></v-progress-linear>
      </template>
  

      <v-avatar color="red" style="width: 200px; height: 200px; float: right; margin: 20px">
        <v-img  :src="dataUrl(infosModelo.FotoPerfil)"
        ></v-img>
      </v-avatar>
      <v-card-title>{{infosModelo.Nome}}</v-card-title>
  
      <v-card-text>
        <div>
         {{infosModelo.Email}}
        </div>
        <div>
         Cupom: {{infosModelo.Cupom}}
        </div>
        <v-card-text>  
          <p class="card-text" v-html="infosModelo != null ? infosModelo.Descricao : ''" />
         </v-card-text>
      </v-card-text>
  
      
      </v-card-text>
    </v-card>

    <v-data-table
    style="max-width: 900px; margin: auto"
    
        :headers="headers"
        :items="desserts"
        item-key="name"
        class="elevation-1"
        :search="search"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label=""
            class="mx-4"
          ></v-text-field>
        </template>
         <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="selecionar(item)"
        >
          {{ icons.mdiPencil }}
        </v-icon>
        <!--<v-icon
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon> -->
      </template>
      </v-data-table>
          

  </div>
</template>

<script>
  import main from '@/assets/scripts/main.js';
  import {
  mdiPencil
} from '@mdi/js'
  export default {
    name: 'Home',
    components: {
      loadingTela: () => import("@/components/layout/loadingTela"),
      siderbar: () => import("@/components/layout/sidebar"),
    },
    computed : {
      
    },
    data: () => ({
      desserts: [],
      icons: {
        mdiPencil
      },
      search: '',
      headers: [
        { text: 'Nome', value: 'Nome' },
        { text: 'Cupom', value: 'Cupom' },
        { text: 'Telefone', value: 'Telefone' },
        { text: 'Selecione', value: 'actions', sortable: false }
      ],


      loading: true,
      fotoCapa: null,
      modelo: null,
      imagemPerfil: "data:image/jpeg;base64,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",
      infosModelo: {
        Descricao: "",
        Email: "",
        FotoPerfil: "",
        Id: "",
        Nome: "",
        Cupom: ""
      },
      carregando: false
    }),
    async created(){
      this.carregando = true;
      const params = new URLSearchParams(window.location.search)
      if(params.get('modelo') != null){
        //localStorage.setItem('origem', params.get('modelo'));
        this.modelo = params.get('modelo');
        var req = {
          modelo: this.modelo
        }
        var resp = await main.postApi(req, "admin/pegarUsuariosPorCodigo"); 
        var retorno = await resp.json();
        if(retorno.sucesso){
          this.infosModelo = retorno.corpo[0];
          this.imagemPerfil = this.dataUrl(this.infosModelo.FotoPerfil);
        }
        this.carregando = false;
      }
      else{
        window.location.assign("Consultor?modelo=RFC170811");
      }


      var eu = this;
      var req = {
        token: localStorage.getItem('cedeppeToken'),
        direcao: 'Entrada',
        status: 'aprovados'
      };
      var resp = await main.postApi(req, "admin/pegarUsuariosCompleto");
      var retorno = await resp.json();
      if(retorno.sucesso){
        this.imagem = retorno.corpo.FotoPerfil;
        this.desserts = retorno.corpo;
        this.loading = false;
      }
      else{
        this.loading = false;
        this.snackbar = true;
        this.msgSnack = retorno.erros
      }
    
    },
    methods: {
      selecionar(item){
       window.location.assign("Consultor?modelo=" + item.Cupom);
      },
      dataUrlTra(imagem){
          return 'data:image/jpeg;base64,' + btoa( new Uint8Array(imagem).reduce((data, byte) => data + String.fromCharCode(byte), ''));
      },

      dataUrl(foto){
        if(this.modelo != null){
          return main.dataUrl(foto, 0)
        }
        else{
          return main.dataUrl(foto, 1)
        }
      },
      pedirCodigo(){
       this.$router.push('Pagamento?tipo=Associacao') 
      },
      ir(caminho){
        window.location.assign("https://cedeppe.global/" + caminho);
      },
      participarTreinamento(caminho){
         window.location.assign("https://cedeppe.global/Pagamento?tipo=" + caminho);
      }
  }
  }
</script>
